module.exports = __webpack_public_path__ + "static-v-shop/1786468182979/img/57243.c258695d.jpg";